import { render, staticRenderFns } from "./levellog.vue?vue&type=template&id=2a463c48&scoped=true&"
import script from "./levellog.vue?vue&type=script&lang=js&"
export * from "./levellog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a463c48",
  null
  
)

export default component.exports